// extracted by mini-css-extract-plugin
export default {"contaner":"Main_contaner__xRst5","textBox":"Main_textBox__h8fGH","title":"Main_title__OoDwp","text":"Main_text__caScT"};